export async function getSHA256Hash(text) {
  if (typeof window === 'undefined' || !window.crypto || !window.crypto.subtle) {
    throw new Error('Web Crypto API is not available.')
  }

  if (typeof text !== 'string') {
    throw new TypeError('Input must be a string.')
  }

  const textAsBuffer = new TextEncoder().encode(text)
  const hashBuffer = await window.crypto.subtle.digest('SHA-256', textAsBuffer)
  const hashArray = Array.from(new Uint8Array(hashBuffer))
  const hash = hashArray.map(item => item.toString(16).padStart(2, '0')).join('')

  return hash
}